import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { DELETE_PRODUCT_RESET, MULTI_PRODUCT_UPDATE_RESET, CREATE_PRODUCT_RESET } from '../redux/constants/productConstants';
import { CREATE_ORDER_RESET } from '../redux/constants/orderConstants';
import { CREATE_RESERVATION_RESET } from '../redux/constants/reservationConstants';

export default function GlobalNotifications() {
    const dispatch = useDispatch();

    // Select messages and errors from various slices
    const { message: productMessage, error: productError } = useSelector(state => state.multiProducts || {});
    const { message: createProductMessage, error: createProductError } = useSelector(state => state.Product || {});
    const { message: deleteProductMessage, error: deleteProductError } = useSelector(state => state.deleteProduct || {});
    const { message: orderMessage, error: orderError } = useSelector(state => state.order || {});
    const { message: reservationMessage, error: reservationError } = useSelector(state => state.reservation || {});
    const { error: userError } = useSelector(state => state.userDetails || {});
    const { message: inviteMessage, error: inviteError } = useSelector(state => state.inviteUser || {});
    const { message: editMessage, error: editError } = useSelector(state => state.allowEditing || {});

    // Helper to trigger toast and reset state
    const triggerToast = useCallback((message, type, resetAction, toastId) => {

        if (!message) return;

        if (type === 'success') {
            toast.success(message, { toastId });
        } else if (type === 'error') {
            toast.error(message, { toastId });
        }

        if (resetAction) {
            setTimeout(() => {

                if (typeof resetAction === 'string') {
                    dispatch({ type: resetAction });
                } else {
                    dispatch(resetAction);
                }

            }, 100);
        }

    }, [dispatch]);

    // Product Slices
    useEffect(() => {
        if (productMessage) triggerToast(productMessage, 'success', MULTI_PRODUCT_UPDATE_RESET, 'product-msg');
        if (productError) triggerToast(productError, 'error', 'CLEAR_ERRORS', 'product-err');

        if (createProductMessage) triggerToast(createProductMessage, 'success', CREATE_PRODUCT_RESET, 'create-prod-msg');
        if (createProductError) triggerToast(createProductError, 'error', 'CLEAR_ERRORS', 'create-prod-err');

        if (deleteProductMessage) triggerToast(deleteProductMessage, 'success', DELETE_PRODUCT_RESET, 'delete-prod-msg');
        if (deleteProductError) triggerToast(deleteProductError, 'error', 'CLEAR_ERRORS', 'delete-prod-err');
    }, [productMessage, productError, createProductMessage, createProductError, deleteProductMessage, deleteProductError, dispatch, triggerToast]);

    // Order Slice
    useEffect(() => {
        if (orderMessage) triggerToast(orderMessage, 'success', CREATE_ORDER_RESET, 'order-success');
        if (orderError) triggerToast(orderError, 'error', 'CLEAR_ERRORS', 'order-error');
    }, [orderMessage, orderError, dispatch, triggerToast]);

    // Reservation Slice
    useEffect(() => {
        if (reservationMessage) triggerToast(reservationMessage, 'success', CREATE_RESERVATION_RESET, 'reservation-success');
        if (reservationError) triggerToast(reservationError, 'error', 'CLEAR_ERRORS', 'reservation-error');
    }, [reservationMessage, reservationError, dispatch, triggerToast]);

    // User/Profile Notifications
    useEffect(() => {
        if (userError) triggerToast(userError, 'error', 'CLEAR_ERRORS', 'user-error');

        if (inviteMessage) triggerToast(inviteMessage, 'success', 'INVITE_USER_RESET', 'invite-success');
        if (inviteError) triggerToast(inviteError, 'error', 'CLEAR_ERRORS', 'invite-error');

        if (editMessage) triggerToast(editMessage, 'success', 'ALLOW_EDITING_RESET', 'edit-success');
        if (editError) triggerToast(editError, 'error', 'CLEAR_ERRORS', 'edit-error');
    }, [userError, inviteMessage, inviteError, editMessage, editError, dispatch, triggerToast]);

    return null;
}
